import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser, useUpdateUser, useUploadUserPhoto } from '../../../hooks/useUsers';
import { useToast } from '../../../hooks/useToast';
import UserForm from '../../../components/forms/UserForm';
import Loading from '../../../components/common/Loading';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { ArrowLeft } from 'lucide-react';

const UserEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: user, isLoading, error, refetch } = useUser(id);
  const updateUser = useUpdateUser();
  const uploadUserPhoto = useUploadUserPhoto();
  const toast = useToast();

  const handleSubmit = async (data) => {
    try {
      const { photoFile, ...userData } = data;
      await updateUser.mutateAsync({ id, data: userData });

      if (photoFile) {
        await uploadUserPhoto.mutateAsync({ id, file: photoFile });
      }

      toast.success('Usuário atualizado com sucesso!');
      navigate('/admin/usuarios');
    } catch (error) {
      toast.error('Erro ao atualizar usuário: ' + error.message);
    }
  };

  if (isLoading) {
    return <Loading text="Carregando usuário..." />;
  }

  if (error) {
    return <ErrorMessage message={error.message} onRetry={refetch} />;
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/usuarios')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Editar Usuário</h1>
        <p className="text-gray-600 mt-1">
          Atualize as informações do usuário
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <UserForm
          initialData={user}
          onSubmit={handleSubmit}
          isLoading={updateUser.isPending || uploadUserPhoto.isPending}
        />
      </div>
    </div>
  );
};

export default UserEdit;
